import { useJsApiLoader } from "@react-google-maps/api"

const useLoadMap = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GATSBY_MAPS_API_KEY,
  })

  return { isLoaded }
}

export default useLoadMap
